// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const ProtobufType = {
    wellKnown: (value) => {
        return {
            value: value,
            type: "wellKnown",
            _visit: function (visitor) {
                return FernIr.ProtobufType._visit(this, visitor);
            },
        };
    },
    userDefined: (value) => {
        return Object.assign(Object.assign({}, value), { type: "userDefined", _visit: function (visitor) {
                return FernIr.ProtobufType._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "wellKnown":
                return visitor.wellKnown(value.value);
            case "userDefined":
                return visitor.userDefined(value);
            default:
                return visitor._other(value);
        }
    },
};
